<!-- @format -->

<template>
  <img class="ava" ref="ava" :onerror="handleError" />
</template>
<script setup>
import { onUpdated, onMounted, ref, toValue } from 'vue'
const defImg = new URL('@/assets/default.png', import.meta.url).href

let props = defineProps({
  url: {
    type: [String, Object],
    default: null,
  },
  error: {
    type: String,
    default: new URL('@/assets/default.png', import.meta.url).href,
  },
})
const ava = ref(null)

let loadedInfo = {
  loaded: false,
  observed: false,
}
const ob = new IntersectionObserver(entries => {
  if (loadedInfo.loaded) {
    return
  }
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      let avatar = entry.target
      let avatarUrl = toValue(props.url) || defImg
      avatar.src = avatarUrl
      loadedInfo.loaded = true
      // console.log("start load:", avatarUrl);
      unobserver()
    }
  })
})
function handleError() {
  ava.value.src = defImg
}
onMounted(() => {
  // console.log("mounted:", props.url);
  observerAva()
})
onUpdated(() => {
  // console.log("onUpdated:", props.url);
  observerAva()
})
function observerAva() {
  if (props.url && !loadedInfo.loaded && !loadedInfo.observed) {
    ob.observe(ava.value)
  }
}
function unobserver() {
  if (loadedInfo.observed) {
    ob.unobserve(ava.value)
  }
}
</script>
<style scoped>
.ava {
  aspect-ratio: 1;
  border-radius: 50%;
  display: block;
  object-fit: cover;
}

.avatarAlignLeft {
  position: absolute;
  top: 0;
  left: 0;
}
.avatarAlignRight {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
